import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NotFoundModel from "./Components/NotFoundModel";
import BookingForm from "./Pages/BookingForm";
import Topbar from "./Components/Topbar";
import Footer from "./Components/Footer";
import ThankYouPage from "./Pages/ThankuPage";

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Topbar />
        <div className="flex-1 overflow-y-auto bg-[#F6F7F8]">
          <Routes>
            <Route path="/:encryptedId" element={<BookingForm />} />
            <Route path="/success" element={<ThankYouPage />} />
            <Route path="*" element={<NotFoundModel />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;
